import script from "./TheOperation.vue?vue&type=script&setup=true&lang=js"
export * from "./TheOperation.vue?vue&type=script&setup=true&lang=js"

import "./TheOperation.vue?vue&type=style&index=0&id=16001021&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/API-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16001021"]])

export default __exports__